var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-my-simple-card',{attrs:{"datacard":_vm.datacard,"isrow":_vm.isrow,"colclass":_vm.colclass,"rowclass":_vm.rowclass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }